export * from './regex';

export const ACTION_BAR_HEIGHT = 48;
export const HEADER_HEIGHT = 64;
export const NAVBAR_MENU_WIDTH = 240;
export const NAVBAR_WIDTH = 64;
export const TAG_CHEVRON_ACTION_ICON_SIZE = 16;
export const TAG_CHEVRON_SIZE = 14;
export const TAG_INDENTATION = 20;
